$base = require './model.base'

module.exports = do ->
  RowDetail: $base.RowDetail
